module.exports = __webpack_public_path__ + "img/term-button-check.7d0e9093.svg";